const initialFileDataState = {
  data : false,
  columns: false

}

export const FileDataReducer = (state = initialFileDataState, action = {}) => {    
  
    switch (action.type) {           
        case 'FILEDATA':       
            return {
              ...state,
              data: action.fetchedFileData.data.data,
              columns: action.fetchedFileData.data.columns

            }
        
     
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/FileDataReducer.js